import { useEffect, useState } from 'react';

/** Long enough that a query answering from cache or a fast network never shows. */
export const LOADING_INDICATOR_DELAY_MS = 250;

/**
 * Follows a flag, but only after it has held true for `delayMs`.
 *
 * A loading indicator that appears the instant a query starts flashes on every
 * fast response — the placeholder is drawn and removed inside a few frames,
 * which reads as a glitch rather than as loading. Waiting first means a request
 * that resolves quickly is never announced at all, and one that genuinely takes
 * time still is. Turning false is immediate: once the answer is in there is
 * nothing to wait for.
 */
export function useDelayedFlag(value: boolean, delayMs = LOADING_INDICATOR_DELAY_MS): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!value) {
      setDelayed(false);
      return;
    }

    const timer = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return delayed;
}
